import { render, staticRenderFns } from "./CreateDocumentOurCompany.vue?vue&type=template&id=2356b08a&scoped=true&"
import script from "./CreateDocumentOurCompany.vue?vue&type=script&lang=js&"
export * from "./CreateDocumentOurCompany.vue?vue&type=script&lang=js&"
import style0 from "./CreateDocumentOurCompany.vue?vue&type=style&index=0&id=2356b08a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2356b08a",
  null
  
)

export default component.exports